import {
    /** FETCH PROFESSIONS  */
    FETCH_REGISTER_FULFILLED,
    FETCH_REGISTER_REJECTED,
    FETCH_REGISTER_PENDING,
    RESET_REGISTER
} from "../../actions/auth/register";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_REGISTER_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_REGISTER_FULFILLED:
            localStorage.setItem("accessToken", action.payload.accessToken)
            localStorage.setItem("refreshToken", action.payload.refreshToken)
            localStorage.setItem("user", JSON.stringify(action.payload.user))
            return {
                ...state,
                register: action.payload,
                done: true,
                error: false,
                spinner: false
            };
        case FETCH_REGISTER_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_REGISTER:
            return {
                initialState,
                spinner: false,
                done: false,
                error: false,
            };
        default:
            return state;
    }
};